export const productData = {
	acrobat: {
		id: 'acrobat',
		name: 'Acrobat DC',
		sapCode: 'APRO',
		customMessage: 'Installing Acrobat Pro DC will uninstall any previous versions of Acrobat purchased as a subscription although previous versions installed with serial number will remain intact. If you require an older version of Acrobat, you can re-install it from Adobe Document Cloud or the Acrobat download page.',
		downloadURL: 'https://adobe.com/go/dcacrobat'
	},
	aftereffects: {
		id: 'aftereffects',
		name: 'After Effects',
		sapCode: 'AEFT',
		downloadURL: 'http://adobe.ly/28PRe53'
	},
	'lightroom-classic': {
		name: 'Lightroom Classic',
		id: 'lightroom-classic',
		sapCode: 'LTRM',
		downloadURL: 'https://www.adobe.com/go/dlnd-lightroom-classic'
	},
	lightroom: {
		name: 'Lightroom',
		id: 'lightroom',
		sapCode: 'LRCC',
		downloadURL: 'https://www.adobe.com/go/dnld-lightroom'
	},
	xd: {
		name: 'XD',
		id: 'xd',
		sapCode: 'SPRK',
		customMessage: 'XD CC requires <b>Windows 10 Creators Update</b> and later. Learn more about Windows 10 Creators Update <a href="CCweb.util.goURL(\'https://www.adobe.com/go/xd-window-update\')" target=\'_blank\'>here</a>.',
		downloadURL: 'https://www.adobe.com/go/dnld-xd'
	},
	animate: {
		id: 'animate',
		name: 'Animate',
		sapCode: 'FLPR',
		downloadURL: 'http://adobe.ly/28ZUiZ9'
	},
	audition: {
		id: 'audition',
		name: 'Audition',
		sapCode: 'AUDT',
		downloadURL: 'https://adobe.com/go/dnld_audition'
	},
	bridge: {
		id: 'bridge',
		name: 'Bridge',
		sapCode: 'KBRG',
		downloadURL: 'https://adobe.com/go/dnld_bridge'
	},
	ccpp: {
		name: 'Lightroom',
		id: 'lightroom',
		planId: 'ccpp',
		sapCode: 'LRCC',
		type: 'application-plan',
		planName: 'Creative Cloud Photography plan',
		nextDownloadName: 'Photoshop',
		customMessage: 'To install the other apps in your plan, go to the Creative Cloud desktop app.',
		downloadURL: 'https://www.adobe.com/go/dlnd-ccpp'
	},
	ccppn: {
		name: 'Lightroom',
		id: 'lightroom',
		planId: 'ccppn',
		sapCode: 'LRCC',
		type: 'application-plan',
		planName: 'Creative Cloud Photography plan with 1TB',
		nextDownloadName: 'Photoshop',
		customMessage: 'To install the other apps in your plan, go to the Creative Cloud desktop app.',
		downloadURL: 'https://www.adobe.com/go/dnld-ccppn'
	},
	lccp: {
		name: 'Lightroom',
		id: 'lightroom',
		planId: 'lccp',
		sapCode: 'LRCC',
		type: 'application-plan',
		planName: 'Lightroom',
		nextDownloadName: 'Lightroom Classic',
		customMessage: 'To install the other apps in your plan, go to the Creative Cloud desktop app.',
		downloadURL: 'https://www.adobe.com/go/dnld-lccp'
	},
	'character-animator': {
		name: 'Character Animator',
		id: 'character-animator',
		sapCode: 'CHAR',
		downloadURL: 'https://www.adobe.com/go/dlnd-character-animator'
	},
	'creative-cloud': {
		name: 'Creative Cloud',
		id: 'creative-cloud',
		sapCode: 'KCCC',
		downloadURL: 'https://adobe.com/go/dnld_creativecloud'
	},
	dimension: {
		name: 'Dimension',
		id: 'dimension',
		sapCode: 'ESHR',
		downloadURL: 'https://www.adobe.com/go/dnld-dimension'
	},
	dreamweaver: {
		name: 'Dreamweaver',
		id: 'dreamweaver',
		sapCode: 'DRWV',
		downloadURL: 'http://adobe.ly/28PRD7y'
	},
	'experience-design': {
		id: 'experience-design',
		name: 'XD',
		sapCode: 'SPRK',
		customMessage: 'XD CC requires <b>Windows 10 Creators Update</b> and later. Learn more about Windows 10 Creators Update <a href="CCweb.util.goURL(\'https://www.adobe.com/go/xd-window-update\')" target=\'_blank\'>here</a>.',
		downloadURL: 'https://www.adobe.com/go/dnld-xd'
	},
	fuse: {
		id: 'fuse',
		name:'Fuse CC (Beta)',
		sapCode: 'FUSE',
		downloadURL: 'https://adobe.com/go/dnld_fuse'
	},
	illustrator: {
		id: 'illustrator',
		name: 'Illustrator',
		sapCode: 'ILST',
		downloadURL: 'http://adobe.ly/28QoDIL'
	},
	incopy: {
		id: 'incopy',
		name: 'InCopy',
		sapCode: 'AICY',
		downloadURL: 'https://adobe.com/go/dnld_incopy'
	},
	indesign: {
		id: 'indesign',
		sapCode: 'IDSN',
		name: 'InDesign',
		downloadURL: 'http://adobe.ly/28PSW4U'
	},
	'media-encoder': {
		id: 'media-encoder',
		sapCode: 'AME',
		name: 'Media Encoder',
		downloadURL: 'https://adobe.com/go/dnld_mediaencoder'
	},
	muse: {
		id: 'muse',
		sapCode: 'MUSE',
		name: 'Muse CC',
		downloadURL: 'http://adobe.ly/28ZVpI5'
	},
	photoshop: {
		id: 'photoshop',
		sapCode: 'PHSP',
		name: 'Photoshop',
		downloadURL: 'http://adobe.ly/28TCmBB'
	},
	prelude: {
		id: 'prelude',
		sapCode: 'PRLD',
		name: 'Prelude',
		downloadURL: 'https://adobe.com/go/dnld_prelude'
	},
	premiere: {
		id: 'premiere',
		sapCode: 'PPRO',
		name: 'Premiere Pro',
		downloadURL: 'http://adobe.ly/28PRl0y'
	},
	rush: {
		id: 'rush',
		sapCode: 'RUSH',
		name: 'Premiere Rush',
		downloadURL: 'https://www.adobe.com/go/dnld-rush'
	},
	'premiere-rush': {
		id: 'rush',
		sapCode: 'RUSH',
		name: 'Premiere Rush',
		downloadURL: 'https://www.adobe.com/go/dnld-rush'
	},
	'fresco-desktop': {
		id: 'fresco-desktop',
		sapCode: 'FRSC',
		name: 'Fresco',
		downloadURL: 'https://www.adobe.com/go/dnld-fresco-desktop'
	},
	aero: {
		id: 'aero',
		sapCode: 'AERO',
		name: 'Aero (Beta)',
		downloadURL: 'https://www.adobe.com/go/dnld_aero'
	},
	'photoshop-express-desktop': {
		id: 'photoshop-express-desktop',
		sapCode: 'PSXUWP',
		name: 'Adobe Photoshop Express',
		downloadURL: 'https://www.adobe.com/go/dnld_photoshop-express-desktop'
	},
	'uxp-developer-tools': {
		id: 'uxp-developer-tools',
		sapCode: 'UXPD',
		name: 'UXP Developer Tools',
		downloadURL: 'https://www.adobe.com/go/dnld_uxp-developer-tools'
	},
	'substance-alchemist': {
		id: 'substance-alchemist',
		sapCode: 'SBSTA',
		name: 'Substance 3D Sampler',
		downloadURL: 'https://www.adobe.com/go/dnld_substance3d-sampler'
	},
	'substance3d-designer': {
		id: 'substance3d-designer',
		sapCode: 'SBSTD',
		name: 'Substance 3D Designer',
		downloadURL: 'https://www.adobe.com/go/dnld_substance3d-designer'
	},
	'substance3d-painter': {
		id: 'substance3d-painter',
		sapCode: 'SBSTP',
		name: 'Substance 3D Painter',
		downloadURL: 'https://www.adobe.com/go/dnld_substance3d-painter'
	},
	'substance3d-stager': {
		id: 'substance3d-stager',
		sapCode: 'STGR',
		name: 'Substance 3D Stager',
		downloadURL: 'https://www.adobe.com/go/dnld_substance3d-stager'
	}
};

export const planArr = ['ccpp','ccppn','lccp'];

export const globalNavLocaleMap = {
	cs: 'cz',
	da: 'dk',
	de: 'de',
	en: 'en',
	es: 'es',
	fi: 'fi',
	fr: 'fr',
	it: 'it',
	ja: 'jp',
	ko: 'kr',
	nb: 'no',
	nl: 'nl',
	pl: 'pl',
	pt: 'pt',
	ru: 'ru',
	sv: 'se',
	tr: 'tr',
	'zh-Hans': 'cn',
	'zh-Hant': 'tw'
};

export const downloadLocaleMap = {
	cs: 'cs_CZ',
	da: 'da_DK',
	de: 'de_DE',
	en: 'en_US',
	es: 'es_ES',
	fi: 'fi_FI',
	fr: 'fr_FR',
	it: 'it_IT',
	ja: 'ja_JP',
	ko: 'ko_KR',
	nb: 'nb_NO',
	nl: 'nl_NL',
	pl: 'pl_PL',
	pt: 'pt_BR',
	ru: 'ru_RU',
	sv: 'sv_SE',
	tr: 'tr_TR',
	'zh-cn': 'zh_CN',
	'zh-tw': 'zh_TW'
};

export const PHSPData = {
	platforms: {
		platform: [
			{
				languageSet: [
					{
						urls: {
							lbsURL: '/AdobeProducts/PHSP/20_0_3/osx10-64/AAMmetadataLS20/CreativeCloudInstaller.dmg',
							aamURL: 'aam://SAPCode=PHSP',
							'cc-uri': {
								uri: [
									{
										value: 'aam://SAPCode=PHSP',
										version: 'default'
									},
									{
										value: 'aam://SAPCode=PHSP?version=20.0.3?actionList=CC-UI',
										version: '2.0.0.0'
									},
									{
										value: 'aam://adobecreativecloud/?SAPCode=PHSP&version=20.0.3&actionList=CC-UI',
										version: '3.0.0.0'
									}
								]
							}
						},
						locales: {
							locale : [
								{
									name: 'en_US'
								}
							]
						}
					}
				],
				id: 'osx10-64'
			},
			{
				languageSet: [
					{
						urls: {
							lbsURL: '/AdobeProducts/PHSP/20_0_3/win64/AAMmetadataLS20/CreativeCloudSet-Up.exe',
							aamURL: 'aam://SAPCode=PHSP',
							'cc-uri': {
								uri: [
									{
										value: 'aam://SAPCode=PHSP',
										version: 'default'
									},
									{
										value: 'aam://SAPCode=PHSP?version=20.0.3?actionList=CC-UI',
										version: '2.0.0.0'
									},
									{
										value: 'aam://adobecreativecloud/?SAPCode=PHSP&version=20.0.3&actionList=CC-UI',
										version: '3.0.0.0'
									}
								]
							}
						},
						locales: {
							locale : [
								{
									name: 'en_US'
								}
							]
						}
					}
				],
				id: 'win64'
			}
		]
	}
};

export const analytics = {
	continueClicked: 'continueClicked',
	skill:'skill',
	job:'job',
	experience:'experience',
	toastRender: 'toastRender',
	toastCloseClick: 'toastCloseClick',
	privacyBannerClicked: 'privacyBannerClicked',
	downloadStart: 'downloadStart',
	downloadStartThor: 'downloadStartThor',
	restartDownloadClicked: 'restartDownloadClicked',
	trialDownloadInstruction: 'trialDownloadInstruction',
	troubleShootingGuide: 'troubleShootingGuide',
	contactSupport: 'contactSupport',
	needHelpClicked: 'needHelpClicked',
	returnAdobeComClicked: 'returnAdobeComClicked',
	errorPageRendered: 'errorPageRendered',
	systemRequirementsClicked: 'systemRequirementsClicked',
	lightroomClassicLinkClicked: 'lightroomClassicLinkClicked',
	learnMoreClicked: 'learnMoreClicked',
	sendMeLinkClicked: 'sendMeLinkClicked',
	mobileScreen: 'mobileScreen',
	learnMoreMuseClicked: 'learnMoreMuseClicked',
	pageNotFoundError: 'pageNotFoundError',
	assetUrlLinkClicked: 'assetUrlLinkClicked',
	serviceUrlLinkClicked: 'serviceUrlLinkClicked'
};

export const additionalDownloadMessageData = {
	AEFT: {
		kaizenMessageId: 'ccd.download.amemessage',
		thorMessageId: 'ccd.thor.instruction.additionalApps',
		additionalProductsList: ['media-encoder']
	},
	FLPR: {
		kaizenMessageId: 'ccd.download.amemessage',
		thorMessageId: 'ccd.thor.instruction.additionalApps',
		additionalProductsList: ['media-encoder']
	},
	PRLD: {
		kaizenMessageId: 'ccd.download.amemessage',
		thorMessageId: 'ccd.thor.instruction.additionalApps',
		additionalProductsList: ['media-encoder']
	},
	PPRO: {
		kaizenMessageId: 'ccd.download.ame_rush_message',
		thorMessageId: 'ccd.thor.instruction.additionalApps',
		additionalProductsList: ['media-encoder', 'rush']
	},
	CHAR: {
		kaizenMessageId: 'ccd.download.amemessage',
		thorMessageId: 'ccd.thor.instruction.additionalApps',
		additionalProductsList: ['media-encoder']
	}
};

export const promotion = {
	install: 'install',
	launch: 'launch',
	panel: 'panel'
};

// List of apps that are supported only on Win or only on Mac
export const singleOSSupportedApps = ['fresco-desktop'];

export const errorTypes = {
	serviceDown: 'serviceDown', /* Used to indicate the cases where error screen will be shown. */
	companionAppDataUnavailable: 'companionAppDataUnavailable',
	videoPanelDataUnavailable: 'videoPanelDataUnavailable'
};

// Redirect for these products
export const productsToRedirectFor = ['lccp', 'experience-design', 'flash', 'flash-builder', 'project-felix', 'muse'];

export const campaignUrlUriMapping = [
	{
		urlId: '/adbps/7904a7cb-2500-4914-9f42-69db84b3fa2a',
		uri: 'adbps://app/v1?consumer.name=CCD&exp.campaign_id=2020-11-Throughline&source.name=PHSP&source.version=22.0&env.com.name=Unified-Panel&action=LearnAndSearch&content.type=cmInAppLearn&locale=en-US&view=browse'
	},
	{
		urlId: '/adbps/c5215251-423b-4cf8-9a70-bf2f148ff654',
		uri: 'adbps://app/v1?consumer.name=CCD&exp.campaign_id=2020-11-Throughline&source.name=PHSP&source.version=22.0&env.com.name=Unified-Panel&action=LearnAndSearch&content.type=cmInAppLearn&content.id=photoshop%2Fhow-to%2Fin-app%2Fadd-an-image&content.name=Add%20an%20image&locale=en-US'
	},
	{
		urlId: '/adbps/5d033618-01b1-48c1-88b8-b59c4772d744',
		uri: 'adbps://app/v1?consumer.name=CCD&exp.campaign_id=2020-11-Throughline&source.name=PHSP&source.version=22.0&env.com.name=Unified-Panel&action=LearnAndSearch&content.type=cmInAppLearn&content.id=photoshop%2Fhow-to%2Fin-app%2Fintroduction-to-the-workspace&content.name=Get%20to%20know%20the%20app&locale=en-US'
	},
	{
		urlId: '/adbps/5d6ecf9b-a2e6-48ab-b052-5f2f01771c2b',
		uri: 'adbps://app/v1?consumer.name=CCD&exp.campaign_id=2020-11-Throughline&source.name=PHSP&source.version=22.0&env.com.name=Unified-Panel&action=LearnAndSearch&content.type=cmInAppLearn&content.id=photoshop%2Fhow-to%2Fin-app%2Fintroduction-to-layers&content.name=Get%20to%20know%20layers&locale=en-US'
	},
	{
		urlId: '/adbps/48e45877-46bc-4ba6-babf-149701246934',
		uri: 'adbps://app/v1?consumer.name=CCD&exp.campaign_id=2020-11-Throughline&source.name=PHSP&source.version=22.0&env.com.name=Unified-Panel&action=LearnAndSearch&content.type=cmInAppLearn&content.id=photoshop%2Fhow-to%2Fin-app%2Fintroduction-to-selections&content.name=Get%20to%20know%20selections&locale=en-US'
	},
	{
		urlId: '/adbps/95324cb8-8eeb-4e06-bd64-eb5fda32c3ee',
		uri: 'adbps://app/v1?consumer.name=CCD&exp.campaign_id=2020-11-Throughline&source.name=PHSP&source.version=22.0&env.com.name=Unified-Panel&action=LearnAndSearch&content.type=cmInAppLearn&content.id=photoshop%2Fhow-to%2Fin-app%2Fshine-light-on-a-dark-photo&content.name=Shine%20light%20on%20a%20dark%20photo%20to%20reveal%20its%20details&locale=en-US'
	},
	{
		urlId: '/adbps/cdb7cc40-76d4-408b-ae37-e3ab67e5c361',
		uri: 'adbps://app/v1?consumer.name=CCD&exp.campaign_id=2020-11-Throughline&source.name=PHSP&source.version=22.0&env.com.name=Unified-Panel&action=LearnAndSearch&content.type=cmInAppLearn&content.id=photoshop%2Fhow-to%2Fin-app%2Fdodge-and-burn-to-lighten-and-darken-parts-of-a-photo&content.name=Dodge%20and%20burn%20to%20lighten%20and%20darken%20parts%20of%20a%20photo&locale=en-US'
	},
	{
		urlId: '/adbps/5a80f03c-087a-48b8-a586-93d9d83aa911',
		uri: 'adbps://app/v1?consumer.name=CCD&exp.campaign_id=2020-11-Throughline&source.name=PHSP&source.version=22.0&env.com.name=Unified-Panel&action=LearnAndSearch&content.type=cmInAppLearn&content.id=photoshop%2Fhow-to%2Fin-app%2Fadjust-lighting-in-a-photo-with-levels&content.name=Adjust%20lighting%20in%20a%20photo%20with%20Levels&locale=en-US'
	},
	{
		urlId: '/adbps/d855e26d-7386-4ab9-9b38-fe4ce8217a7f',
		uri: 'adbps://app/v1?consumer.name=CCD&exp.campaign_id=2020-11-Throughline&source.name=PHSP&source.version=22.0&env.com.name=Unified-Panel&action=LearnAndSearch&content.type=cmInAppLearn&content.id=photoshop%2Fhow-to%2Fin-app%2Fcontrol-photo-brightness-and-contrast-with-curves&content.name=Control%20photo%20brightness%20and%20contrast%20with%20Curves&locale=en-US'
	},
	{
		urlId: '/adbps/0a7da4b7-7724-4653-92fa-b7872b6e8446',
		uri: 'adbps://app/v1?consumer.name=CCD&exp.campaign_id=2020-11-Throughline&source.name=PHSP&source.version=22.0&env.com.name=Unified-Panel&action=LearnAndSearch&content.type=cmInAppLearn&content.id=photoshop%2Fhow-to%2Fin-app%2Fadjust-color-vibrance-in-a-portrait-photo&content.name=Adjust%20color%20vibrance%20in%20a%20portrait%20photo&locale=en-US'
	},
	{
		urlId: '/adbps/36d3cd45-bba1-4d56-9e74-4c0832ded1b6',
		uri: 'adbps://app/v1?consumer.name=CCD&exp.campaign_id=2020-11-Throughline&source.name=PHSP&source.version=22.0&env.com.name=Unified-Panel&action=LearnAndSearch&content.type=cmInAppLearn&content.id=photoshop%2Fhow-to%2Fin-app%2Fmake-colors-pop&content.name=Make%20colors%20pop%20in%20a%20photo&locale=en-US'
	},
	{
		urlId: '/adbps/8f280055-d54a-488b-b5da-40a7c7eb0384',
		uri: 'adbps://app/v1?consumer.name=CCD&exp.campaign_id=2020-11-Throughline&source.name=PHSP&source.version=22.0&env.com.name=Unified-Panel&action=LearnAndSearch&content.type=cmInAppLearn&content.id=photoshop%2Fhow-to%2Fblack-and-white&content.name=Custom%20black%20and%20white&locale=en-US'
	},
	{
		urlId: '/adbps/133c8888-7d0e-401d-aeed-d83e91c1f208',
		uri: 'adbps://app/v1?consumer.name=CCD&exp.campaign_id=2020-11-Throughline&source.name=PHSP&source.version=22.0&env.com.name=Unified-Panel&action=LearnAndSearch&content.type=cmInAppLearn&content.id=photoshop%2Fhow-to%2Fin-app%2Fchange-the-color-of-objects&content.name=Change%20the%20color%20of%20an%20object&locale=en-US'
	},
	{
		urlId: '/adbps/1191f866-e39e-4872-8f7b-ce9624d8e553',
		uri: 'adbps://app/v1?consumer.name=CCD&exp.campaign_id=2020-11-Throughline&source.name=PHSP&source.version=22.0&env.com.name=Unified-Panel&action=LearnAndSearch&content.type=cmInAppLearn&content.id=photoshop%2Fhow-to%2Fremove-small-imperfections&content.name=Remove%20small%20imperfections&locale=en-US'
	},
	{
		urlId: '/adbps/d7db4e4e-9742-44c6-9a74-a09e00bd4b3f',
		uri: 'adbps://app/v1?consumer.name=CCD&exp.campaign_id=2020-11-Throughline&source.name=PHSP&source.version=22.0&env.com.name=Unified-Panel&action=LearnAndSearch&content.type=cmInAppLearn&content.id=photoshop%2Fhow-to%2Fin-app%2Ffix-an-old-photo&content.name=fix%20an%20old%20photo=en-US'
	},
	{
		urlId: '/adbps/d4b1fa63-2a86-45fe-99fc-672d7c4f87b1',
		uri: 'adbps://app/v1?consumer.name=CCD&exp.campaign_id=2020-11-Throughline&source.name=PHSP&source.version=22.0&env.com.name=Unified-Panel&action=LearnAndSearch&content.type=cmInAppLearn&content.id=photoshop%2Fhow-to%2Fin-app%2Fcrop-and-straighten-a-photo-to-improve-composition&content.name=Crop%20and%20straighten%20a%20photo%20to%20improve%20composition&locale=en-US'
	},
	{
		urlId: '/adbps/28915ab4-0a92-4580-8b92-ac33f315f2c8',
		uri: 'adbps://app/v1?consumer.name=CCD&exp.campaign_id=2020-11-Throughline&source.name=PHSP&source.version=22.0&env.com.name=Unified-Panel&action=LearnAndSearch&content.type=cmInAppLearn&content.id=photoshop%2Fhow-to%2Fin-app%2Fresize-an-image&content.name=Resize%20an%20image&locale=en-US'
	},
	{
		urlId: '/adbps/0816e278-7c0d-4c62-800d-5a62ad1cc6f1',
		uri: 'adbps://app/v1?consumer.name=CCD&exp.campaign_id=2020-11-Throughline&source.name=PHSP&source.version=22.0&env.com.name=Unified-Panel&action=LearnAndSearch&content.type=cmInAppLearn&content.id=photoshop%2Fhow-to%2Fin-app%2Fresize-a-layer-with-transform&content.name=Resize%20a%20layer&locale=en-US'
	},
	{
		urlId: '/adbps/cc12a4fa-ce71-4930-8613-18cfb1249164',
		uri: 'adbps://app/v1?consumer.name=CCD&exp.campaign_id=2020-11-Throughline&source.name=PHSP&source.version=22.0&env.com.name=Unified-Panel&action=LearnAndSearch&content.type=cmInAppLearn&content.id=photoshop%2Fhow-to%2Fin-app%2Fchange-the-background-color-in-a-photo&content.name=Change%20the%20background%20color%20in%20a%20photo&locale=en-US'
	},
	{
		urlId: '/adbps/88d47876-2266-487b-b7b1-c6f5c22a1574',
		uri: 'adbps://app/v1?consumer.name=CCD&exp.campaign_id=2020-11-Throughline&source.name=PHSP&source.version=22.0&env.com.name=Unified-Panel&action=LearnAndSearch&content.type=cmInAppLearn&content.id=photoshop%2Fhow-to%2Fin-app%2Fremove-and-replace-a-photo-background&content.name=Remove%20and%20replace%20a%20photo%20background&locale=en-US'
	},
	{
		urlId: '/adbps/8bf38803-d4b5-468d-8b33-fb92ba3a5561',
		uri: 'adbps://app/v1?consumer.name=CCD&exp.campaign_id=2020-11-Throughline&source.name=PHSP&source.version=22.0&env.com.name=Unified-Panel&action=LearnAndSearch&content.type=cmInAppLearn&content.id=photoshop%2Fhow-to%2Fin-app%2Fcombine-images-with-blend-modes&content.name=Combine%20images%20with%20blend%20modes&locale=en-US'
	},
	{
		urlId: '/adbps/8daba7ae-c9ba-41de-92c7-363e6df6443c',
		uri: 'adbps://app/v1?consumer.name=CCD&exp.campaign_id=2020-11-Throughline&source.name=PHSP&source.version=22.0&env.com.name=Unified-Panel&action=LearnAndSearch&content.type=cmInAppLearn&content.id=photoshop%2Fhow-to%2Fin-app%2Fmake-a-double-exposure&content.name=Make%20a%20double%20exposure&locale=en-US'
	},
	{
		urlId: '/adbps/d3c73472-a738-4b0b-ab3e-c8788de20199',
		uri: 'adbps://app/v1?consumer.name=CCD&source.name=PHSP&source.version=22.0&env.com.name=Unified-Panel&action=LearnAndSearch&content.type=cmInAppLearn&content.id=photoshop/how-to/in-app/combine-images-to-create-a-composite-using-layer-masks&content.name=Combine%20images%20to%20create%20a%20composite%20with%20layer%20masks&locale=en-US'
	},
	{
		urlId: '/adbps/bd65b3ea-2dc5-4145-8551-3bb530f9eca9',
		uri: 'adbps://app/v1?consumer.name=CCD&exp.campaign_id=2020-11-Throughline&source.name=PHSP&source.version=22.0&env.com.name=Unified-Panel&action=LearnAndSearch&content.type=cmInAppLearn&content.id=photoshop%2Fhow-to%2Fin-app%2Fcreate-a-tattoo&content.name=Create%20a%20tattoo&locale=en-US'
	},
	{
		urlId: '/adbps/4bf1103a-1a3c-4c4b-a09c-d9effc54b499',
		uri: 'adbps://app/v1?consumer.name=CCD&exp.campaign_id=2020-11-Throughline&source.name=PHSP&source.version=22.0&env.com.name=Unified-Panel&action=LearnAndSearch&content.type=cmInAppLearn&content.id=photoshop%2Fhow-to%2Fin-app%2Fcreate-and-edit-text&content.name=Create%20and%20edit%20text&locale=en-US'
	},
	{
		urlId: '/adbps/4ee38ed2-922d-4ec4-8723-67f958d4be3b',
		uri: 'adbps://app/v1?consumer.name=CCD&exp.campaign_id=2020-11-Throughline&source.name=PHSP&source.version=22.0&env.com.name=Unified-Panel&action=LearnAndSearch&content.type=cmInAppLearn&content.id=photoshop%2Fhow-to%2Fin-app%2Fmake-a-social-media-image-with-photos-and-text&content.name=Make%20a%20social%20media%20image%20with%20photos%20and%20text&locale=en-US'
	},
	{
		urlId: '/adbps/e7c790c3-c2ef-45f4-8095-b5c6bf177b42',
		uri: 'adbps://app/v1?consumer.name=CCD&source.name=PHSP&source.version=22.0&env.com.name=Unified-Panel&action=LearnAndSearch&content.type=cmInAppLearn&content.id=photoshop/how-to/in-app/animated-gif&content.name=Create%20an%20animated%20GIF&locale=en-US'
	},
	{
		urlId: '/adbps/44bef45a-d311-4775-a18f-c5eb89bffdef',
		uri: 'adbps://app/v1?consumer.name=CCD&exp.campaign_id=2020-11-Throughline&source.name=PHSP&source.version=22.0&env.com.name=Unified-Panel&action=LearnAndSearch&content.type=cmInAppLearn&content.id=photoshop%2Fhow-to%2Fin-app%2Fuse-artboards-to-experiment-with-layouts&content.name=Use%20artboards%20to%20experiment%20with%20layouts&locale=en-US'
	},
	{
		urlId: '/adbps/0c1e56d7-b275-46b3-aeea-d5143bb0f971',
		uri: 'adbps://app/v1?consumer.name=CCD&exp.campaign_id=2020-11-Throughline&source.name=PHSP&source.version=22.0&env.com.name=Unified-Panel&action=LearnAndSearch&content.type=cmInAppLearn&content.id=photoshop%2Fhow-to%2Fchoose-colors-for-painting&content.name=Choose%20colors%20for%20painting&locale=en-US'
	},
	{
		urlId: '/adbps/f57cac27-063e-405e-9615-9e38823ce061',
		uri: 'adbps://app/v1?consumer.name=CCD&exp.campaign_id=2020-11-Throughline&source.name=PHSP&source.version=22.0&env.com.name=Unified-Panel&action=LearnAndSearch&content.type=cmInAppLearn&content.id=photoshop%2Fhow-to%2Fin-app%2Fpaint-color-and-texture-on-an-object&content.name=Paint%20color%20and%20texture%20on%20an%20object&locale=en-US'
	},
	{
		urlId: '/adbps/4135f974-1f14-4dc3-a8d8-f9b66f4743c4',
		uri: 'adbps://app/v1?consumer.name=CCD&exp.campaign_id=2020-11-Throughline&source.name=PHSP&source.version=22.0&env.com.name=Unified-Panel&action=LearnAndSearch&content.type=cmHelpXDetail&content.id=photoshop%2Fhow-to%2Fps-basics-fundamentals&content.name=Get%20to%20know%20Photoshop&locale=en-US'
	},
	{
		urlId: '/adbps/ee5e6507-0e74-46d8-8449-6ffecb9a7b12',
		uri: 'adbps://app/v1?consumer.name=CCD&exp.campaign_id=2020-11-Throughline&source.name=PHSP&source.version=22.0&env.com.name=Unified-Panel&action=LearnAndSearch&content.type=cmHelpXDetail&content.id=photoshop%2Fhow-to%2Fimage-resizing-basics&content.name=Change%20the%20image%20size&locale=en-US'
	},
	{
		urlId: '/adbps/e42ad0b4-d3fc-4877-a311-0dd9994ff2a5',
		uri: 'adbps://app/v1?consumer.name=CCD&exp.campaign_id=2020-11-Throughline&source.name=PHSP&source.version=22.0&env.com.name=Unified-Panel&action=LearnAndSearch&content.type=cmHelpXDetail&content.id=photoshop%2Fhow-to%2Fps-layers-basics&content.name=Work%20with%20layers&locale=en-US'
	},
	{
		urlId: '/adbps/5035a652-4028-4352-bf79-415fa48561f3',
		uri: 'adbps://app/v1?consumer.name=CCD&exp.campaign_id=2020-11-Throughline&source.name=PHSP&source.version=22.0&env.com.name=Unified-Panel&action=LearnAndSearch&content.type=cmHelpXDetail&content.id=photoshop%2Fhow-to%2Fmake-animated-gif&content.name=Create%20an%20animated%20GIF%20from%20a%20series%20of%20photos&locale=en-US'
	},
	{
		urlId: '/adbps/edd1b6d6-f1ab-4188-b193-7c6a90d6c171',
		uri: 'adbps://app/v1?consumer.name=CCD&exp.campaign_id=2020-11-Throughline&source.name=PHSP&source.version=22.0&env.com.name=Unified-Panel&action=LearnAndSearch&content.type=cmHelpXDetail&content.id=photoshop%2Fhow-to%2Fgraphic-design-basics&content.name=Create%20your%20first%20design&locale=en-US'
	},
	{
		urlId: '/adbps/50ec3616-4fb3-4976-b2c0-0b9b5602ae2f',
		uri: 'adbps://app/v1?consumer.name=CCD&exp.campaign_id=2020-11-Throughline&source.name=PHSP&source.version=22.0&env.com.name=Unified-Panel&action=LearnAndSearch&content.type=cmHelpXDetail&content.id=photoshop%2Fhow-to%2Fphoto-enhancement-basics&content.name=Adjust%20the%20image%20quality&locale=en-US'
	},
	{
		urlId: '/adbps/09c52423-069f-40dc-a1a5-f6ffeb29d742',
		uri: 'adbps://app/v1?consumer.name=CCD&exp.campaign_id=2020-11-Throughline&source.name=PHSP&source.version=22.0&env.com.name=Unified-Panel&action=LearnAndSearch&content.type=cmHelpXDetail&content.id=photoshop%2Fhow-to%2Fcontent-aware-hide-objects&content.name=Remove%20objects%20with%20Content-Aware%20Fill&locale=en-US'
	},
	{
		urlId: '/adbps/1befa484-59fc-431c-913d-a6933702f30a',
		uri: 'adbps://app/v1?consumer.name=CCD&exp.campaign_id=2020-11-Throughline&source.name=PHSP&source.version=22.0&env.com.name=Unified-Panel&action=LearnAndSearch&content.type=cmHelpXDetail&content.id=photoshop%2Fhow-to%2Fselection-tools-basics&content.name=Make%20selections&locale=en-US'
	},
	{
		urlId: '/adbps/71e8a443-34de-40cb-aa8a-3b4eaee96d39',
		uri: 'adbps://app/v1?consumer.name=CCD&exp.campaign_id=2020-11-Throughline&source.name=PHSP&source.version=22.0&env.com.name=Unified-Panel&action=LearnAndSearch&content.type=cmHelpXDetail&content.id=photoshop%2Fhow-to%2Fresize-image&content.name=Change%20the%20size%20of%20an%20image&locale=en-US'
	},
	{
		urlId: '/adbps/bb9f081f-8983-40b3-b3bb-17b92d72ea43',
		uri: 'adbps://app/v1?consumer.name=CCD&exp.campaign_id=2020-11-Throughline&source.name=PHSP&source.version=22.0&env.com.name=Unified-Panel&action=LearnAndSearch&content.type=cmHelpXDetail&content.id=photoshop%2Fhow-to%2Fadd-border-frame-around-photo&content.name=Create%20a%20border%20or%20frame%20around%20an%20image&locale=en-US'
	},
	{
		urlId: '/adbps/cd060d6e-e4fc-478c-ad08-d337e3e8a95d',
		uri: 'adbps://app/v1?consumer.name=CCD&exp.campaign_id=2020-11-Throughline&source.name=PHSP&source.version=22.0&env.com.name=Unified-Panel&action=LearnAndSearch&content.type=cmHelpXDetail&content.id=photoshop%2Fhow-to%2Fmatch-font-image&content.name=Match%20fonts%20from%20an%20image&locale=en-US'
	},
	{
		urlId: '/adbps/88c38bc1-6553-410f-975b-25c32b042b00',
		uri: 'adbps://app/v1?consumer.name=CCD&exp.campaign_id=2020-11-Throughline&source.name=PHSP&source.version=22.0&env.com.name=Unified-Panel&action=LearnAndSearch&content.type=cmHelpXDetail&content.id=photoshop%2Fhow-to%2Freplace-image-background&content.name=How%20to%20create%20a%20new%20background%20in%20Adobe%20Photoshop&locale=en-US'
	},
	{
		urlId: '/adbps/abc7ba09-6b7f-4922-a534-0bbbab9a6b7c',
		uri: 'adbps://app/v1?consumer.name=CCD&exp.campaign_id=2020-11-Throughline&source.name=PHSP&source.version=22.0&env.com.name=Unified-Panel&action=LearnAndSearch&content.type=cmHelpXDetail&content.id=photoshop%2Fhow-to%2Fselection-masking-space&content.name=Accurately%20select%20image%20areas&locale=en-US'
	},
	{
		urlId: '/adbps/3109a574-9ebe-4da0-9c6d-740bfc83261c',
		uri: 'adbps://app/v1?consumer.name=CCD&exp.campaign_id=2020-11-Throughline&source.name=PHSP&source.version=22.0&env.com.name=Unified-Panel&action=LearnAndSearch&content.type=cmHelpXDetail&content.id=photoshop%2Fhow-to%2Fcombining-images-basics&content.name=Combine%20images&locale=en-US'
	},
	{
		urlId: '/adbps/56b0cf4a-6013-4232-9b84-1019c950f545',
		uri: 'adbps://app/v1?consumer.name=CCD&exp.campaign_id=2020-11-Throughline&source.name=PHSP&source.version=22.0&env.com.name=Unified-Panel&action=LearnAndSearch&content.type=cmHelpXDetail&content.id=photoshop%2Fhow-to%2Fcolor-management-basics&content.name=Use%20color&locale=en-US'
	},
	{
		urlId: '/adbps/0341fcb2-8f01-4b80-8c99-84cfac51781a',
		uri: 'adbps://app/v1?consumer.name=CCD&exp.campaign_id=2020-11-Throughline&source.name=PHSP&source.version=22.0&env.com.name=Unified-Panel&action=LearnAndSearch&content.type=cmHelpXDetail&content.id=photoshop%2Fhow-to%2Fphoto-retouching-basics&content.name=Retouch%20images&locale=en-US'
	},
	{
		urlId: '/adbps/e74b0857-2981-4c9a-a731-13b8f34aaede',
		uri: 'adbps://app/v1?consumer.name=CCD&exp.campaign_id=2020-11-Throughline&source.name=PHSP&source.version=22.0&env.com.name=Unified-Panel&action=LearnAndSearch&content.type=cmHelpXDetail&content.id=photoshop%2Fhow-to%2Fadding-text-shapes-basics&content.name=Add%20text%20and%20shapes&locale=en-US'
	},
	{
		urlId: '/adbps/51ff03b9-3c49-48e6-be87-171a73bf6ba3',
		uri: 'adbps://app/v1?consumer.name=CCD&exp.campaign_id=2020-11-Throughline&source.name=PHSP&source.version=22.0&env.com.name=Unified-Panel&action=LearnAndSearch&content.type=cmHelpXDetail&content.id=photoshop%2Fhow-to%2Fphotoshop-for-beginners&content.name=Master%20these%20fundamental%20tools&locale=en-US'
	},
	{
		urlId: '/adbps/954bfa58-2561-4420-b542-3400e733b8a0',
		uri: 'adbps://app/v1?consumer.name=CCD&exp.campaign_id=2020-11-Throughline&source.name=PHSP&source.version=22.0&env.com.name=Unified-Panel&action=LearnAndSearch&content.type=cmHelpXDetail&content.id=photoshop%2Fhow-to%2Flightroom-to-photoshop&content.name=Start%20using%20Lightroom%20Classic%20with%20Photoshop&locale=en-US'
	},
	{
		urlId: '/adbps/03f465b3-a46a-4fbc-b978-5add780dce78',
		uri: 'adbps://app/v1?consumer.name=CCD&exp.campaign_id=2020-11-Throughline&source.name=PHSP&source.version=22.0&env.com.name=Unified-Panel&action=LearnAndSearch&content.type=cmHelpXDetail&content.id=photoshop%2Fhow-to%2Fadd-text-photo&content.name=Enhance%20your%20photos%20with%20text&locale=en-US'
	},
	{
		urlId: '/adbps/7a924d69-8dc7-4e34-9019-951f67d839a3',
		uri: 'adbps://app/v1?consumer.name=CCD&exp.campaign_id=2020-11-Throughline&source.name=PHSP&source.version=22.0&env.com.name=Unified-Panel&action=LearnAndSearch&content.type=cmHelpXDetail&content.id=photoshop%2Fhow-to%2Fadd-motion-blur-effects&content.name=Add%20creative%20blur%20to%20photos&locale=en-US'
	},
	{
		urlId: '/adbps/7b3d6d9d-deaa-4591-ac30-fbcf3407d3ad',
		uri: 'adbps://app/v1?consumer.name=CCD&exp.campaign_id=2020-11-Throughline&source.name=PHSP&source.version=22.0&env.com.name=Unified-Panel&action=LearnAndSearch&content.type=cmHelpXDetail&content.id=photoshop%2Fhow-to%2Fselection-masking-space&content.name=Accurately%20select%20image%20areas&locale=en-US'
	},
	{
		urlId: '/adbps/088665b0-37f8-4252-8c96-6f69f6cdd65e',
		uri: 'adbps://app/v1?consumer.name=CCD&exp.campaign_id=2020-11-Throughline&source.name=PHSP&source.version=22.0&env.com.name=Unified-Panel&action=LearnAndSearch&content.type=cmHelpXDetail&content.id=photoshop%2Fhow-to%2Fblur-background-for-focal-point&content.name=Focus%20on%20your%20subject,%20blur%20the%20rest&locale=en-US'
	},
	{
		urlId: '/adbps/92a9f649-531e-417d-9b52-e03b0e216378',
		uri: 'adbps://app/v1?consumer.name=CCD&exp.campaign_id=2020-11-Throughline&source.name=PHSP&source.version=22.0&env.com.name=Unified-Panel&action=LearnAndSearch&content.type=cmHelpXDetail&content.id=photoshop%2Fhow-to%2Fphoto-retouching&content.name=Combine,%20retouch,%20and%20add%20effects%20to%20photos&locale=en-US'
	},
	{
		urlId: '/adbps/75c98b6d-0e2e-44a4-a9fe-08c7ba9c368d',
		uri: 'adbps://app/v1?consumer.name=CCD&exp.campaign_id=2020-11-Throughline&source.name=PHSP&source.version=22.0&env.com.name=Unified-Panel&action=LearnAndSearch&content.type=cmHelpXDetail&content.id=photoshop%2Fhow-to%2Fcomposite-add-move-images&content.name=Combine%20photos%20and%20images&locale=en-US'
	},
	{
		urlId: '/adbps/3eb50967-b22f-4db2-853d-6046e87cead3',
		uri: 'adbps://app/v1?consumer.name=CCD&exp.campaign_id=2020-11-Throughline&source.name=PHSP&source.version=22.0&env.com.name=Unified-Panel&action=LearnAndSearch&content.type=cmHelpXDetail&content.id=photoshop%2Fhow-to%2Foverview-for-beginners&content.name=Dream%20it.%20Make%20it.&locale=en-US'
	},
	{
		urlId: '/adbps/804eda05-a46a-4069-b4ef-170acfc02f45',
		uri: 'adbps://app/v1?consumer.name=CCD&exp.campaign_id=2020-11-Throughline&source.name=PHSP&source.version=22.0&env.com.name=Unified-Panel&action=LearnAndSearch&content.type=cmHelpXDetail&content.id=photoshop%2Fhow-to%2Fphotoshop-templates&content.name=Jump-start%20your%20designs%20with%20Photoshop%20templates&locale=en-US'
	},
	{
		urlId: '/adbps/3a71fe8e-50d3-41e8-bfff-6e04308eca84',
		uri: 'adbps://app/v1?consumer.name=CCD&exp.campaign_id=2020-11-Throughline&source.name=PHSP&source.version=22.0&env.com.name=Unified-Panel&action=LearnAndSearch&content.type=cmHelpXDetail&content.id=photoshop%2Fhow-to%2Fapplying-filters-basics&content.name=Apply%20filters&locale=en-US'
	}
];
